import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BookingTabs from '../components/booking/BookingTabs';
import RentalForm from '../components/booking/RentalForm';
import WeddingForm from '../components/booking/WeddingForm';
import ComingSoon from '../components/booking/ComingSoon';
import Footer from '../components/common/Footer';
import '../components/booking/ServicePage.css';

const TAB_TO_FORM = {
  'taxipool': () => <ComingSoon serviceName="TaxiPool"      icon="🚗" tagline="Shared rides at up to 40% off. We're matching demand across routes — drop your number and you'll be first in line." />,
  'hourly':   RentalForm,
  'tours':    () => <ComingSoon serviceName="Bihar Tours"   icon="🏛️" tagline="Bodh Gaya, Rajgir, Nalanda & curated multi-day packages. Launching soon with verified local drivers." />,
  'wedding':  WeddingForm,
  'shifting': () => <ComingSoon serviceName="House Shifting" icon="📦" tagline="Porter-style trucks with GPS tracking & trained loaders. Currently onboarding fleet partners across Bihar." />,
};

const DEFAULT_TAB = 'taxipool';

const ServicePage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const initialTab = (() => {
    const t = new URLSearchParams(location.search).get('tab');
    return TAB_TO_FORM[t] ? t : DEFAULT_TAB;
  })();

  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    const t = new URLSearchParams(location.search).get('tab');
    if (t === 'one-way') {
      navigate('/', { replace: true });
      return;
    }
    if (t && TAB_TO_FORM[t] && t !== activeTab) setActiveTab(t);
  }, [location.search, activeTab, navigate]);

  const handleTabChange = (t) => {
    setActiveTab(t);
    navigate(`/services?tab=${t}`, { replace: true });
  };

  const ActiveForm = TAB_TO_FORM[activeTab];

  return (
    <div className="service-page">
      <div className="tab-bar-wrap">
        <BookingTabs activeTab={activeTab} onTabChange={handleTabChange} />
      </div>
      {ActiveForm && <ActiveForm />}
      <Footer />
    </div>
  );
};

export default ServicePage;
